import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { ConfirmDialogComponent } from "src/app/services/dialog/confirm-dialog/confirm-dialog.component";
import { CompanyMaintenanceService } from "../company-maintenance.service";
import { PATTERN_ALPHA_NUMERIC_WITH_SPACE, PATTERN_NUMERIC, PATTERN_ALPHA_NUMERIC_WITH_SPACE_NO_OTHER_SPC_CHAR } from "src/app/utils/constant";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DialogService, HelperService, LanguageService } from "src/app/services";
import { environment } from "src/environments/environment";
import { MediaObserver } from "@angular/flex-layout";
import { finalize } from "rxjs/operators";
import * as _ from "lodash";

@Component({
  selector: 'esc-company-maintenance-form',
  templateUrl: './company-maintenance-form.component.html',
  styleUrls: ['./company-maintenance-form.component.scss']
})
export class CompanyMaintenanceFormComponent implements OnInit {
  @Input() detail;
  @Input() mode;
  @Output() saving = new EventEmitter();
  @Output() closeForm = new EventEmitter();

  public isDisabled;
  loading = {
    submit: false
  };
  countryRequired;
  regionRequired;
  provinceRequired;
  cityRequired;
  industryRequired;

  constructor(
    private fb: FormBuilder,
    public helper: HelperService,
    public media: MediaObserver,
    private dialogService: DialogService,
    public languageService: LanguageService,
    public companyMntSvc: CompanyMaintenanceService
  ) {}

  public formGroup: FormGroup;

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.formGroup = this.fb.group({
      // prefix: [_.get(this.detail, "coupon_prefix_code"), [Validators.required, Validators.maxLength(2), Validators.pattern(PATTERN_ALPHA_NUMERIC_WITH_SPACE)]],

      code: [_.get(this.detail, "code"), [Validators.maxLength(2), Validators.pattern(PATTERN_ALPHA_NUMERIC_WITH_SPACE)]],

      description: [_.get(this.detail, "description"), [Validators.required, Validators.maxLength(50), Validators.pattern(PATTERN_ALPHA_NUMERIC_WITH_SPACE_NO_OTHER_SPC_CHAR)]],

      country: [_.get(this.detail, "country")],

      region: [_.get(this.detail, "region")],

      province: [_.get(this.detail, "province")],

      city: [_.get(this.detail, "city"), [Validators.required]],

      street: [_.get(this.detail, "street"), [Validators.required, Validators.maxLength(50)]],

      image_url: [_.get(this.detail, "image_url")],

      image_original_uploaded_filename: [_.get(this.detail, "image_original_uploaded_filename"), [Validators.required]],

      contact_person: [_.get(this.detail, "contact_person"), [Validators.required, Validators.maxLength(50), Validators.pattern(PATTERN_ALPHA_NUMERIC_WITH_SPACE)]],

      contact_number: [_.get(this.detail, "contact_number"), [Validators.required, Validators.maxLength(16), Validators.pattern(PATTERN_NUMERIC)]],

      industry: [_.get(this.detail, "industry"), [Validators.required]],

      esc_sales_manager: [_.get(this.detail, "esc_sales_manager"), [Validators.required, Validators.maxLength(50), Validators.pattern(PATTERN_ALPHA_NUMERIC_WITH_SPACE)]],

      esc_project_manager: [_.get(this.detail, "esc_project_manager"), [Validators.required, Validators.maxLength(50), Validators.pattern(PATTERN_ALPHA_NUMERIC_WITH_SPACE)]],

      handling_fee: [_.get(this.detail, "handling_fee_value"), [Validators.required, Validators.max(100), this.helper.decimalTwoPlaces]],

      status: _.get(this.detail, "is_active") == 1 ? true : false
    });

    this.toggleDisable();
  }

  toggleDisable() {
    if (!_.get(this.detail, 'id')) {
      this.formGroup.get("status").disable({ emitEvent: false });
      this.formGroup.get("status").setValue(true);
    } 
    else {
      this.formGroup.get("code").disable({ emitEvent: false });
    }
  }

  citySelected(ev) {
    let temp = _.cloneDeep(this.detail) || {};
    this.detail = null;

    this.formGroup.get('country').setValue(_.get(ev, 'country'));
    temp.country = _.get(ev, 'country');

    this.formGroup.get('region').setValue(_.get(ev, 'region'));
    temp.region = _.get(ev, 'region');

    this.formGroup.get('province').setValue(_.get(ev, 'province'));
    temp.province = _.get(ev, 'province');

    this.formGroup.get('city').setValue(ev);
    this.formGroup.get('city').markAsTouched();
    this.detail =_.cloneDeep(temp);
  }

  industryTypeSelected(ev) {
    this.formGroup.get('industry').setValue(ev);
    this.formGroup.get('industry').markAsTouched();
  }

  isFormValid() {
    if(this.formGroup.valid) {
      this.saveChanges()
    }
    else {
      for (let ctrl in this.formGroup.controls) {
        if(!this.formGroup.controls[ctrl].valid) {
          this[ctrl+"Required"] = true;
        }
      }
    }
  }

  saveChanges() {
    this.loading.submit = true;
    this.formGroup.disable();
    this.isDisabled = true;

    let is_active = _.get(this.formGroup.get("status"), "value") ? 1 : 0;

    let obj = {
      data: [
        {
          id: _.get(this.detail, "id") || 0,

          coupon_prefix_code: _.toUpper(_.get(this.formGroup.get("code"), "value")),

          code: _.toUpper(_.get(this.formGroup.get("code"), "value")),

          description: _.toUpper(_.get(this.formGroup.get("description"), "value")),

          city_id: _.toInteger(_.get(this.formGroup.get("city"), "value.id") || 1),

          street: _.toUpper(_.get(this.formGroup.get("street"), "value")),

          image_url: _.get(this.formGroup.get("image_url"), "value"),

          image_original_uploaded_filename: _.get(this.formGroup.get("image_original_uploaded_filename"), "value"),

          contact_person: _.toUpper(_.get(this.formGroup.get("contact_person"), "value")),

          contact_number: _.toInteger(_.get(this.formGroup.get("contact_number"), "value")),

          industry_type_id: _.toInteger(_.get(this.formGroup.get("industry"), "value.id") || 1),

          esc_sales_manager: _.toUpper(_.get(this.formGroup.get("esc_sales_manager"), "value")),

          esc_project_manager: _.toUpper(_.get(this.formGroup.get("esc_project_manager"), "value")),

          handling_fee_value: parseFloat(_.get(this.formGroup.get("handling_fee"), "value")),

          is_active: is_active
        }
      ]
    };

    this.saving.emit(true);

    this.companyMntSvc.insert(obj).pipe(
      finalize(() => {
        this.loading.submit = false;
        this.saving.emit(false);
        this.formGroup.enable();
        this.toggleDisable();
        this.isDisabled = false;
      }))
      .subscribe(
        (res: any) => {
          if (environment.showLogs) {
            console.log(res);
          }

          if (_.has(res, 'status') && _.get(res, 'status') == 0) {
            this.helper.networkErrorMessage();
            return;
          }

          if(this.helper.displayErrorMessage(res)) return;
          
          if (_.get(res, 'success.count') > 0) {
            //the ff needs to be an obj to display detail correctly
            obj.data[0]["country"] = _.get(this.formGroup.get("country"), "value");
            obj.data[0]["region"] = _.get(this.formGroup.get("region"), "value");
            obj.data[0]["province"] = _.get(this.formGroup.get("province"), "value");
            obj.data[0]["city"] = _.get(this.formGroup.get("city"), "value");
            obj.data[0]["industry"] = _.get(this.formGroup.get("industry"), "value");

            this.saving.emit(obj.data);
            this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_DATA_UPDATED", {}));
            this.close(true);
          }
        },
        err => {
          console.log(err);
        }
      );
  }

  disableSaveBtn() {
    return this.loading.submit || (this.formGroup.touched && !this.formGroup.valid)
  }

  confirmChanges() {
    if(this.formGroup.touched && this.formGroup.valid) {
      this.dialogService.openDialog(ConfirmDialogComponent, {
        width: "400px",
        autoFocus: true,
        disableClose: true,
        data: {
          title: this.languageService.getTranslation("MSG_CONFIRM_ACTION", {}),
          message: this.languageService.getTranslation("MSG_SAVE_CHANGES", {}),
          button: this.languageService.getTranslation("LABEL_YES", {}),
          cancelButton: this.languageService.getTranslation("LABEL_NO", {}),
        }
      })
      .afterClosed()
      .subscribe(result => {
        if(result) {
          this.saveChanges();
        } else {
          this.close(false);
        }
      })
    }
    else {
      this.close(false);
    }
  }

  close(data) {
    this.closeForm.next(data);
  }
}